/*  */

//*componentes-utiles
//*datos

//*clases

//*componente
    export default function PaginaMenu1() {
    return (
        <div className="container container-Vista" >
        <h1>Página menu 1</h1>
        <br></br>
        </div>
    );
    }
